import { FsTrackPick } from "db/model/match/Track/FsTrackPick";
import { PickType, TrackPick } from "model/Match/TrackPick";
import { nonUndefined } from "Utility";

export const mapTrackPicks = (fsModels: FsTrackPick[]): TrackPick[] => {
  return nonUndefined(fsModels.map((p) => mapTrackPick(p)));
};

const mapTrackPick = (fsModel: FsTrackPick): TrackPick | undefined => {
  if (!fsModel.trackId) {
    return undefined;
  }

  return {
    rosterId: fsModel.rosterId,
    pickType: mapPickType(fsModel.pickType, fsModel.rosterId),
    trackId: fsModel.trackId,
  };
};

const mapPickType = (
  type: string | undefined,
  rosterId: string | undefined
): PickType => {
  switch (type) {
    case "Ban":
      return "Ban";
    case "Pick":
      return !!rosterId ? "Pick" : "Random";
    case "Random":
    default:
      return "Random";
  }
};
